import { IconButton, Typography } from '@mui/material'
import LinkedInIcon from 'components/Icons/LinkedInIcon'
import TwitterIcon from 'components/Icons/TwitterIcon'
import { ButtonsContainer, Divider, ShareSocialButtonsContainer } from './styled'

const ShareSocialButtons = ({
  cardComponent = false,
  postSlug,
}: {
  cardComponent?: boolean
  postSlug: string
}) => {
  const baseUrl = process.env.NEXT_PUBLIC_APP_BASE_URL || ''
  const postUrl = `${baseUrl}/blog/${postSlug}`
  const encodedUrl = encodeURIComponent(postUrl)

  const shareLinks = {
    linkedin: {
      title: 'Share on LinkedIn',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      icon: <LinkedInIcon fontSize={cardComponent ? '16' : '24'} />,
    },
    twitter: {
      title: 'Share on X',
      url: `https://x.com/intent/tweet?url=${encodedUrl}`,
      icon: <TwitterIcon fontSize={cardComponent ? '16' : '24'} />,
    },
  }

  return (
    <ShareSocialButtonsContainer cardComponent={cardComponent}>
      <Typography variant="overline" color="surface.400">
        Share
      </Typography>
      {cardComponent && <Divider />}
      <ButtonsContainer cardComponent={cardComponent} onClick={(e) => e.stopPropagation()}>
        {Object.entries(shareLinks).map(([key, { title, url, icon }]) => (
          <IconButton
            key={key}
            component="a"
            href={url}
            title={title}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ padding: 0 }}
          >
            {icon}
          </IconButton>
        ))}
      </ButtonsContainer>
    </ShareSocialButtonsContainer>
  )
}

export default ShareSocialButtons
